import MyExpApi from "apps/myExperience/enum/MyExpApi";
import { QueryClient } from "react-query";
import { ApiRegistrationParticipantForDashboardDetails } from "../../../../shared/types/ApiRegistrationParticipantForDashboardDetails";
import TicketStatus from "../../../../shared/enums/TicketStatus";
import { refreshParticipantDetails, updateTicketStatusInParticipantDetails } from "../participantDetails/dataloader";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";

export function getDashboardQueryKey(regParticipantId?: string) {
  return getApiQueryKey(MyExpApi.DASHBOARD_DETAILS, {
    pathParams: { registrationParticipantId: regParticipantId }
  });
}

export function useGetDashboardDetails({ regParticipantId }: { regParticipantId?: string }) {
  return useGetApiData<ApiRegistrationParticipantForDashboardDetails>(
    MyExpApi.DASHBOARD_DETAILS,
    {
      pathParams: { registrationParticipantId: regParticipantId }
    },
    {
      enabled: Boolean(regParticipantId)
    }
  );
}

export function refreshDashboardData(queryClient: QueryClient, regParticipantId?: string) {
  queryClient.invalidateQueries(getDashboardQueryKey(regParticipantId));
  refreshParticipantDetails(queryClient, regParticipantId);
}

export function updateTicketStatusInDashboardData(
  queryClient: QueryClient,
  regParticipantId?: string,
  ticketStatus?: TicketStatus
) {
  queryClient.setQueryData(
    getDashboardQueryKey(regParticipantId),
    (data?: ApiRegistrationParticipantForDashboardDetails) => {
      return { ...data, ticketStatus: ticketStatus } as ApiRegistrationParticipantForDashboardDetails;
    }
  );
  updateTicketStatusInParticipantDetails(queryClient, regParticipantId, ticketStatus);
}
